<script setup>
import { onMounted, computed } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import { useAdmin } from 'dashboard/composables/useAdmin';

const store = useStore();

const { isAdmin } = useAdmin();
const currentUser = useMapGetter('getCurrentUser');
const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const allAgents = useMapGetter('agents/getAgents');

const agents = computed(() => {
  if (isAdmin.value) {
    return allAgents.value;
  }
  if (currentUser.value && allAgents.value) {
    return allAgents.value.filter(agent => agent.id === currentUser.value.id);
  }
  return [];
});

const fetchData = () => {
  const params = {};
  if (!isAdmin.value && currentUser.value) {
    params.userId = currentUser.value.id;
  }
  store.dispatch('fetchAgentConversationMetric', params);
};

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('agents/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')">
      <AgentTable
        :agents="agents"
        :agent-metrics="agentConversationMetric"
        :is-loading="uiFlags.isFetchingAgentConversationMetric"
      />
    </MetricCard>
  </div>
</template>
